<template>
  <div>
    <v-select v-model="choiceValue" class="ma-5" :items="items" label="Select your action" outlined></v-select>
    <v-file-input class="ma-5" v-model="files" color="primary" counter label="File input" prepend-icon="mdi-paperclip"
      outlined :show-size="1000">
      <template v-slot:selection="{ index, text }">
        <v-chip v-if="index < 2" color="primary" dark label small>
          {{ text }}
        </v-chip>
        <span v-else-if="index === 2" class="overline grey--text text--darken-3 mx-2">
          +{{ files.length - 2 }} File(s)
        </span>
      </template>
    </v-file-input>
    <p v-if="isErrorWhileParsing" class="">
      Error while parsing file : not valid json file
    </p>
    <v-btn :disabled="!isButtonActive" @click="send" class="ma-5">
      <!-- <p v-if="choiceValue!=null"></p> -->
      Send {{ choiceValue }}
    </v-btn>

    <v-btn v-if="choiceValue != null && choiceValue.charAt(0) === 'S'" @click="deactivateStandby" class="ma-5">
      Deactivate standby
    </v-btn>
    <v-btn v-if="choiceValue != null && choiceValue.charAt(0) === 'S'" @click="dates = true" class="ma-5">
      Deactivate kiosk
    </v-btn>

    <v-dialog v-model="dates" max-width="400">
      <v-card>
        <v-card-title>
          Choisir les dates de début et de fin de désactivation
        </v-card-title>

        <v-card-text>
          <!-- Date de début -->
          <v-menu v-model="menuStart" :close-on-content-click="false" transition="scale-transition" offset-y
            min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="startDateFormatted" label="Date de début" prepend-icon="mdi-calendar" readonly
                v-bind="attrs" v-on="on" />
            </template>

            <v-date-picker v-model="startDate" locale="fr" @input="menuStart = false" />
          </v-menu>

          <!-- Date de fin -->
          <v-menu v-model="menuEnd" :close-on-content-click="false" transition="scale-transition" offset-y
            min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="endDateFormatted" label="Date de fin" prepend-icon="mdi-calendar" readonly v-bind="attrs"
                v-on="on" :error="endDateInvalid" :error-messages="endDateInvalid ? ['La date de fin doit être après la date de début'] : []"/>
            </template>

            <v-date-picker v-model="endDate" locale="fr" @input="checkEndDate" />
          </v-menu>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dates = false">Annuler</v-btn>
          <v-btn color="primary" @click="deactivateKiosk" :disabled="!startDate || !endDate || endDateInvalid">
            Valider
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>
<script>
export default {
  data: () => ({
    items: ["GetParam", "SetParam"],
    choiceValue: null,
    files: null,
    fileContent: null,
    isErrorWhileParsing: false,
    dataToSend: { params: null, setOrGet: null },
    dates: false,
    selectedDates: [],
    menu: false,
    menuStart: false,
    menuEnd: false,
    startDate: null,
    endDate: null,
    endDateInvalid: false
  }),
  methods: {
    checkEndDate() {
      // Ferme le menu
      this.menuEnd = false

      if (!this.startDate || !this.endDate) {
        this.endDateInvalid = false
        return
      }

      const start = new Date(this.startDate)
      const end = new Date(this.endDate)

      this.endDateInvalid = end < start
    },
    formatDate(date) {
      const d = new Date(date)
      const day = String(d.getDate()).padStart(2, '0')
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const year = d.getFullYear()
      return `${day}-${month}-${year}`
    },
    send: function () {
      this.formatDatas();
      this.$emit("sendGetSetParam", this.dataToSend);
    },
    formatDatas: function () {
      this.dataToSend.setOrGet =
        this.choiceValue === "GetParam" ? "get" : "set";
      this.dataToSend.params = this.fileContent;
    },
    deactivateStandby: function () {
      this.dataToSend.setOrGet = "set";
      const data = [
        { "paramName": "SLEEP_ACTIVE", "value": "0" }
      ];
      this.dataToSend.params = data
      this.$emit("sendGetSetParam", this.dataToSend);
    },
    deactivateKiosk: function () {
      this.dataToSend.setOrGet = "set";
      const data = [
        { "paramName": "SALE_STATE", "value": this.startDateFormatted + "/" + this.endDateFormatted + "/Pending" }
      ];
      this.dataToSend.params = data
      this.$emit("sendGetSetParam", this.dataToSend);
      this.dates = false
    },
  },
  computed: {
    startDateFormatted() {
      return this.startDate ? this.formatDate(this.startDate) : ''
    },
    endDateFormatted() {
      return this.endDate ? this.formatDate(this.endDate) : ''
    },
    isButtonActive() {
      return (
        this.value !== null && this.files != null && !this.isErrorWhileParsing
      );
    },
    dateRangeText() {
      if (!this.selectedDates.start || !this.selectedDates.end) return ''
      return `${this.selectedDates.start} → ${this.selectedDates.end}`
    }
  },
  watch: {
    files() {
      if (this.files == null) {
        //console.log("user remove file");
      } else {
        var reader = new FileReader();
        // Use the javascript reader object to load the contents
        // of the file in the v-model prop
        reader.readAsText(this.files);
        reader.onload = () => {
          this.isErrorWhileParsing = false;
          try {
            this.dataToSend.params = null;
            let tmp = eval(reader.result);
            this.fileContent = tmp;
          } catch (error) {
            this.isErrorWhileParsing = true;
          }
        };
      }
    },
  },
};
</script>